<template>
  <div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import type { Ref } from "vue";

type Props = {
  modelValue: string;
};
type Events = {
  (e: "update:modelValue", v: string): void;
};
type TabsContext = {
  modelValue: Ref<string>;
  onChange: (value: string) => void;
};

const tabsContextKey = "ui-tabs";

export const useTabsContext = () => {
  const context = inject<TabsContext>(tabsContextKey);

  if (!context) {
    throw `Couldn't find ui-tabs context.`;
  }

  return context;
};

export default {
  inheritAttrs: true,
};
</script>

<script setup lang="ts">
import { inject, provide, toRef } from "vue";

const props = defineProps<Props>();
const emit = defineEmits<Events>();

provide<TabsContext>(tabsContextKey, {
  modelValue: toRef(() => props.modelValue),
  onChange: (value: string) => emit("update:modelValue", value),
});
</script>
